// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Js_dict from "rescript/lib/es6/js_dict.js";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";
import * as Belt_SetInt from "rescript/lib/es6/belt_SetInt.js";
import * as UserContext$LiteracyplanetClientFlags from "@literacyplanet/client-flags/src/UserContext.res.mjs";
import * as LocalStorage$LiteracyplanetClientFlags from "@literacyplanet/client-flags/src/LocalStorage.res.mjs";
import * as WordFlyersTypes$LiteracyplanetClientSxEntry from "./WordFlyersTypes.res.mjs";

var key = "wfBadges";

function toString(dict) {
  return Belt_Option.getWithDefault(JSON.stringify(dict), "{}");
}

function fromString(data) {
  return Belt_Option.map(data, (function (d) {
                return JSON.parse(d);
              }));
}

var LocalStorageConfig = {
  key: key,
  toString: toString,
  fromString: fromString
};

var BadgesStorage = LocalStorage$LiteracyplanetClientFlags.Make({
      key: key,
      fromString: fromString,
      toString: toString
    });

function useWithNamespace(userId) {
  return BadgesStorage.useLocalStorageWithNamespace(userId);
}

function use() {
  var match = WordFlyersTypes$LiteracyplanetClientSxEntry.use();
  var onGetMatrixActivity = match.onGetMatrixActivity;
  var match$1 = match.data;
  var journeyGate = match$1.journeyGate;
  var user = UserContext$LiteracyplanetClientFlags.use();
  var userId = user.userId;
  var match$2 = BadgesStorage.useLocalStorageWithNamespace(userId);
  var setBadgesSeen = match$2[1];
  var match$3 = React.useState(function () {
        
      });
  var setClaimedBadge = match$3[1];
  var badgesDict = Belt_Option.getWithDefault(match$2[0], {});
  var journeyBadges = Belt_SetInt.fromArray(Belt_Option.getWithDefault(Js_dict.get(badgesDict, journeyGate), []));
  var hasUnitBadge = function (activities) {
    return activities.every(function (a) {
                var match = onGetMatrixActivity(a.id);
                if (typeof match !== "object") {
                  return false;
                }
                var match$1 = match._0.bestAttempt;
                if (match$1 !== undefined) {
                  return match$1.accuracy >= 80;
                } else {
                  return false;
                }
              });
  };
  var availableUnitBadges = Belt_Array.reduceWithIndex(match$1.units, undefined, (function (bdgs, param, idx) {
          if (hasUnitBadge(param.activities)) {
            return Belt_SetInt.add(bdgs, idx + 1 | 0);
          } else {
            return bdgs;
          }
        }));
  React.useEffect((function () {
          var badgeToClaim = Belt_Option.flatMap(Belt_SetInt.maximum(availableUnitBadges), (function (b) {
                  if (Belt_SetInt.has(journeyBadges, b)) {
                    return ;
                  } else {
                    return b;
                  }
                }));
          setClaimedBadge(function (param) {
                return badgeToClaim;
              });
          badgesDict[journeyGate] = Belt_SetInt.toArray(availableUnitBadges);
          setBadgesSeen(badgesDict);
        }), [journeyGate]);
  return [
          availableUnitBadges,
          match$3[0]
        ];
}

export {
  LocalStorageConfig ,
  BadgesStorage ,
  useWithNamespace ,
  use ,
}
/* BadgesStorage Not a pure module */
